import { EventEmitter } from '@angular/core';
var ItemComponent = (function () {
    function ItemComponent() {
        this.tabNum = 0;
        this.checkElse = false;
        this.outPutDownload = new EventEmitter();
        this.outPutData = new EventEmitter();
        this.outPutFileLoad = new EventEmitter();
        this.outPutDelFile = new EventEmitter();
        this.outPutCanSave = new EventEmitter();
        this.outPutPreview = new EventEmitter();
        this.outGetNextBtn = new EventEmitter();
        this.assetsRoute = '../../../assets';
        this.disabledAdd = false;
        this.disabledUpload = false;
        this.isShowAnalysis = false; //是否显示实时答案
        this.singleCurrentId = 0; //单选题选择的optionid
        this.multipleAnswers = ""; //多选题正确答案optionid
        this.showViewAnswerBtn = true; //是否展示查看答案按钮
        this.disableAnswerBtn = true; //是否禁查看答案用按钮
        this.isShowToast = false;
        this.destext = "";
        this.campId = 0;
        this.pcUrl = 'https://m.transtalent.cn/pc/applytask'; //day14提示去pc链接
        this.toastTip = "";
        this.intelligentTitleType = ["文本题", "单选题", "表格题", "多选题", "附件题", "表格题", "文本题", "表格题"];
        this.campTitleType = ["文本题", "单选题", "表格题", "多选题", "附件题", "表格题", "文本题", "表格题"];
    }
    ItemComponent.prototype.ngOnInit = function () {
        this.pcUrl = window.location.hostname === 'm.transtalent.cn' ? 'https://m.transtalent.cn/pc/applytask' : 'https://m-uat.transtalent.cn/pc/applytask';
        this.campId = Number(localStorage.getItem('campId'));
        this.initTypeData();
    };
    ItemComponent.prototype.ngAfterViewInit = function () {
        if (this.question['type'] === 6) {
            this.textareaAutoHeight();
            if (this.question.disable == 0) {
                $(".table-textarea").attr("disabled", true);
            }
            else {
                $(".table-textarea").attr("disabled", false);
            }
        }
    };
    ItemComponent.prototype.initTypeData = function () {
        var _this = this;
        if (this.question['type'] === 3 || this.question['type'] === 6 || this.question['type'] === 8) {
            this.stepGroup = this.question['tableData'].length > 0 ? this.question['tableData'] : [[]];
            while (typeof (this.stepGroup) !== 'object') {
                this.stepGroup = JSON.parse(this.stepGroup);
            }
            this.stepGroupCopy = this.stepGroup;
        }
        else if (this.question['type'] === 2 && !this.isLastDay) {
            this.isShowAnalysis = this.question.options.filter(function (item) { return item['select']; }).length > 0;
            this.singleCurrentId = this.isShowAnalysis ? this.question.options.filter(function (item) { return item['select']; })[0].optionId : 0;
            if (this.isShowAnalysis) {
                this.analysis = this.question.options.filter(function (item) { return item['select']; })[0]['analysis'];
            }
        }
        else if (this.question['type'] === 4 && !this.isFirstDay && !this.isLastDay && this.page == 'answer') {
            this.question['options'].forEach(function (item) {
                if (item.correct) {
                    _this.multipleAnswers += item.optionId + "|";
                }
            });
            if (this.question.options.some(function (item) { return item.select; }) && this.question['options'].filter(function (item) { return item.select; }).length >= 2) {
                this.judgeMulSelect();
            }
        }
        if (this.question['type'] === 7 && this.page == "answer" && JSON.parse(this.question.extendText)) {
            this.imgList = JSON.parse(this.question.extendText);
        }
    };
    /**
     * 添加一个步骤
     * @param id: Number   问题Id
     */
    ItemComponent.prototype.addStep = function (id) {
        if (this.stepGroup.length === 9) {
            this.disabledAdd = true;
        }
        //跳转到对应位置
        var ele = document.querySelector(".add-step");
        setTimeout(function () {
            ele.scrollIntoView();
        }, 100);
        this.outPutCanSave.emit(true);
        if (this.stepGroup.length < 10) {
            this.stepGroup.push(['', '']);
            if (this.stepGroup) {
                this.outPutData.emit({
                    'constituteId': this.lpmapcId,
                    'questionId': id,
                    'tableData': this.stepGroup,
                    'type': 3
                });
            }
            else {
                this.outPutData.emit({
                    'constituteId': this.lpmapcId,
                    'questionId': id,
                    'type': 3
                });
            }
        }
        else {
            return;
        }
    };
    //删除一个步骤
    ItemComponent.prototype.minusStep = function (index, id) {
        this.disabledAdd = false;
        this.outPutCanSave.emit(true);
        this.stepGroup.splice(index, 1);
        if (this.stepGroup) {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'tableData': this.stepGroup,
                'type': 3
            });
        }
        else {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'type': 3
            });
        }
    };
    //获取单选题答案
    ItemComponent.prototype.getRadioAnswer = function (answers) {
        var _this = this;
        if (this.isLastDay && this.tabNum == 1) {
            return this.question['answers'];
        }
        else {
            //为了处理训练营第一道题是多选题但type为2的历史数据
            if (answers.indexOf("|") !== -1) {
                var answersArr = answers.split("|");
                var newAnswerArr_1 = "";
                answersArr.forEach(function (item) {
                    if (item) {
                        var index = _this.question['options'].findIndex(function (v) { return v['optionId'] === Number(item); });
                        newAnswerArr_1 += _this.question['options'][index]['context'] + "<br>";
                    }
                });
                return newAnswerArr_1;
            }
            else {
                var index = this.question['options'].findIndex(function (v) { return v['optionId'] === Number(answers); });
                return this.question['options'][index]['context'];
            }
        }
    };
    //步骤题
    ItemComponent.prototype.stepBlur = function (id, stepGroupIdx) {
        this.outPutCanSave.emit(true);
        this.stepGroup[stepGroupIdx][0] = $('.input-' + id).eq(stepGroupIdx).val() ? $('.input-' + id).eq(stepGroupIdx).val() : '';
        this.stepGroup[stepGroupIdx][1] = this.stepGroup[stepGroupIdx][1] ? this.stepGroup[stepGroupIdx][1] : '';
        if (this.stepGroup) {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'tableData': this.stepGroup,
                'type': 3
            });
        }
        else {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'type': 3
            });
        }
    };
    ItemComponent.prototype.adjustHeight = function (textareaElement, minHeight) {
        // 设置高度为0以防需要收缩（高度）
        textareaElement.style.height = 0;
        // 设置正确的高度
        // el.scrollHeight 是文本内容的全部高度，而不仅仅是可见部分的。
        textareaElement.style.height = Math.max(minHeight, textareaElement.scrollHeight) + 'px';
    };
    ItemComponent.prototype.textareaAutoHeight = function () {
        var textarea = document.querySelectorAll('.table-textarea');
        var _loop_1 = function (i) {
            var el = textarea[i];
            var minHeight = el.scrollHeight;
            var that = this_1;
            el.addEventListener('input', function (e) {
                that.adjustHeight(this, minHeight);
            });
            // 我们调整初始内容的高度
            this_1.adjustHeight(el, minHeight);
        };
        var this_1 = this;
        for (var i = 0; i < textarea.length; i++) {
            _loop_1(i);
        }
    };
    //表格题
    ItemComponent.prototype.tableBlur = function (id, stepGroupIdx) {
        this.outPutCanSave.emit(true);
        // this.stepGroup[stepGroupIdx][0] = $('.input-' + id).eq(stepGroupIdx).val() ? $('.input-' + id).eq(stepGroupIdx).val() : '';
        this.stepGroup[stepGroupIdx][0] = $('.textarea-' + id).eq(stepGroupIdx).val() ? $('.textarea-' + id).eq(stepGroupIdx).val() : '';
        this.stepGroup[stepGroupIdx][1] = this.stepGroup[stepGroupIdx][1] ? this.stepGroup[stepGroupIdx][1] : '';
        if (this.stepGroup) {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'tableData': this.stepGroup,
                'type': 6
            });
        }
        else {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'type': 6
            });
        }
    };
    /**
     * 预览
     * @param url:  String     预览文件的地址
     * @param type: Number     预览文件的类型
     */
    ItemComponent.prototype.showPreview = function (url, type) {
        this.outPutPreview.emit({ 'fileUrl': url, 'fileType': type });
    };
    /**
     * 单选题选中
     * @param id: Number     题目Id
     * @param index: Number  题目下标
     * @param optId: Number  选项Id
     */
    ItemComponent.prototype.optSelected = function (id, index, optId, correct, analysis) {
        this.singleCurrentId = optId;
        this.outPutCanSave.emit(true);
        $('.question-' + id).find('li').eq(index).addClass('active').siblings().removeClass('active');
        this.isShowAnalysis = true;
        this.analysis = analysis;
        if (optId) {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'selector': optId,
                'type': 2
            });
        }
        else {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': id,
                'type': 2
            });
        }
    };
    /**
     * 下载PDF文件
     * @param url: String PDF's URL
     */
    ItemComponent.prototype.downloadPDF = function (url) {
        this.outPutDownload.emit(url);
    };
    /**
     * 不定项选择题选中
     * @param e: InputObj  事件对象
     * @param id: Number   问题Id
     */
    ItemComponent.prototype.checkboxSelected = function (index, id) {
        var _this = this;
        //实战作业day14多选题最多选三个判断逻辑
        if (this.isLastDay) {
            if (this.question['options'].filter(function (item) { return item.select; }).length < 3 || this.question['options'][index].select) {
                this.multiSelect(index, id);
            }
            else {
                this.isShowToast = true;
                this.destext = "请聚焦到3个选项吧！";
                setTimeout(function () {
                    _this.isShowToast = false;
                }, 2000);
            }
        }
        else if (this.isFirstDay) {
            this.multiSelect(index, id);
        }
        else if (!this.isLastDay && !this.isFirstDay) {
            this.multiSelect(index, id);
            this.showViewAnswerBtn = true;
            if (this.question['options'].filter(function (item) { return item.select; }).length >= 2) {
                this.disableAnswerBtn = false;
            }
            else {
                this.disableAnswerBtn = true;
                this.isShowAnalysis = false;
            }
        }
    };
    //多选题选中逻辑
    ItemComponent.prototype.multiSelect = function (index, id) {
        var _this = this;
        this.checkBoxData = "";
        this.question['options'][index].select = !this.question['options'][index].select;
        this.question['options'].forEach(function (item) {
            if (item.select) {
                _this.checkBoxData += item.optionId + "|";
            }
        });
        this.outPutCanSave.emit(true);
        // this.checkBoxData = e.target.checked ? this.checkBoxData + $(e.target).val() + '|' : this.checkBoxData.replace($(e.target).val() + '|', '');
        this.outPutData.emit({
            'constituteId': this.lpmapcId,
            'questionId': id,
            'selector': this.checkBoxData,
            'type': 4
        });
        this.isShowAnalysis = false;
    };
    //查看多选题答案解析
    ItemComponent.prototype.viewAnswer = function () {
        if (!this.disableAnswerBtn) {
            this.showViewAnswerBtn = false;
            this.outGetNextBtn.emit(true);
            this.judgeMulSelect();
        }
    };
    //查看智能作业多选题解析
    ItemComponent.prototype.judgeMulSelect = function () {
        var _this = this;
        this.isShowAnalysis = true;
        this.analysis = this.question['options'].filter(function (item) { return (_this.multipleAnswers == _this.checkBoxData) ? item.correct == 1 : item.correct == 0; })[0].analysis;
    };
    /**
     * 触发文件上传
     */
    ItemComponent.prototype.startUpload = function () {
        console.log(this.uploadList);
        if (this.uploadDisabled) {
            return false;
        }
        else {
            $('#upload_input').click();
        }
    };
    /**
     * 文件上传
     * @param e: input[type='file'] 上传input对象
     * @param id: number  问题Id
     */
    ItemComponent.prototype.uploadFile = function (e, id) {
        var formData = new FormData();
        formData.append('file', $(e.target)[0].files[0]);
        this.outPutFileLoad.emit({ 'files': formData, 'id': id, 'el': e.target });
        $(e.target).attr('type', 'text');
    };
    /**
     * 上传文件删除
     * @param index: Number  上传文件的下标
     * @param id: Number      题目Id
     */
    ItemComponent.prototype.deleteFile = function (index, id) {
        window.event.cancelBubble = true;
        this.outPutDelFile.emit({ 'index': index, 'id': id });
    };
    ItemComponent.prototype.expend = function (relationId, id) {
        var arrow = $('#arrow-' + relationId + '-' + id), body = $('.answer-' + relationId + '-' + id);
        if (arrow.hasClass('rotateX180')) {
            arrow.removeClass('rotateX180');
            body.addClass('height0');
        }
        else {
            arrow.addClass('rotateX180');
            body.removeClass('height0');
        }
    };
    /**
     * 获取文本组件传递过来的数据
     * @param event: Object 文本框数据对象
     */
    ItemComponent.prototype.getTextareaComponentValue = function (event) {
        this.outPutCanSave.emit(true);
        if (event['type'] === 3 || event['type'] === 6 || this.question['type'] === 8) {
            this.stepGroup[event['index']][0] = this.stepGroup[event['index']][0] ? this.stepGroup[event['index']][0] : '';
            this.stepGroup[event['index']][1] = event['content'] ? event['content'] : '';
        }
        if (event['type'] === 3 || event['type'] === 6 || this.question['type'] === 8) {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': event['questionId'],
                'tableData': this.stepGroup,
                'type': event['type'],
                'wordOverrun': event['wordOverrun']
            });
        }
        else {
            this.outPutData.emit({
                'constituteId': this.lpmapcId,
                'questionId': event['questionId'],
                'selector': event['content'],
                'type': event['type'],
                'wordOverrun': event['wordOverrun']
            });
        }
    };
    //复制链接
    ItemComponent.prototype.copyUrl = function () {
        var _this = this;
        if (window.navigator) {
            window.navigator.clipboard.writeText(window.location.hostname === 'm.transtalent.cn' ? "https://m.transtalent.cn/pc/#/?actualwork=true" : "https://m-uat.transtalent.cn/pc/#/?actualwork=true").then(function (r) {
                _this.isShowToast = true;
                _this.toastTip = "square";
                _this.destext = "复制成功";
                setTimeout(function () {
                    _this.isShowToast = false;
                }, 1500);
            });
        }
    };
    ItemComponent.prototype.inputFocus = function (event, i) {
        var exerciseItemWrap = document.getElementById("exercise-item-wrap-active");
        var answerStepWrap = document.getElementById("answer-step-wrap-" + i);
        if (i == 0)
            exerciseItemWrap.scrollTop = answerStepWrap.offsetTop;
    };
    return ItemComponent;
}());
export { ItemComponent };



// WEBPACK FOOTER //
// ./src/app/app-exercise-work/exercise-work-item/item.component.ts.pre-build-optimizer.js